/**
 * Created by Andromeda on 11/19/16.
 */
'use strict';
//contractors
import './assets/css/contractors.css';



// WEBPACK FOOTER //
// ./packages/custom/contractors/public/index.js